/**
 * A chat's title and id, from its first prompt — the same on every data
 * source, so a chat is named alike whether the mock or the live API holds it.
 */

/** How long a title can be before it is cut. Figma's breadcrumb truncates anyway. */
export const TITLE_MAX = 80;

/** A chat's title is its first prompt, on one line, cut at a word. */
export function titleFor(prompt: string): string {
  const line = prompt.replace(/\s+/g, ' ').trim();
  if (line.length <= TITLE_MAX) return line;
  const cut = line.slice(0, TITLE_MAX);
  return `${cut.slice(0, Math.max(cut.lastIndexOf(' '), TITLE_MAX - 20))}…`;
}

/** A slug for a new chat's id, unique against the ids already taken. */
export function chatIdFor(title: string, taken: ReadonlySet<string>): string {
  const base =
    title
      .toLowerCase()
      .replace(/[^a-z0-9]+/g, '-')
      .replace(/^-|-$/g, '')
      .slice(0, 48) || 'chat';
  if (!taken.has(base)) return base;
  let i = 2;
  while (taken.has(`${base}-${i}`)) i += 1;
  return `${base}-${i}`;
}
